<template>
  <modal
    :is-hidden="isHidden"
    :is-open="isOpen"
    :title="filename"
    ref="modal"
    v-on:clickclose="closeDialog"
    :alert="alertTitle"
    :alert-style="alertStyle"
    :alert-text="alertText"
    :alert-icon="alertIcon"
    alert-dismissable
    v-on:dismissalert="closeAlert"
    v-on:close="reset"
    :fixed="true"
  >
    <div class=" preview">
      <img v-if="isImage" :src="src"/>
      <stl-viewer v-else-if="isStl" :src="src" :key="src"/>
      <div v-else-if="filename" class="fi-container">
        <div class="fi-wrapper">
          <span :style="{background: iconColor}"
                class="fileicon fileicon-lg"
          >{{ extension }}</span>
        </div>
        <div class="fi-filename">No preview available</div>
      </div>
    </div>
    <template slot="footer">
      <a v-if="downloadable" :href="src" target="_blank" class="btn btn-sm btn-info" style="float: left"><i class="fas fa-download"></i> {{ $t('Action.download') }}</a>
      <button type="button" class="btn btn-sm btn-default" v-on:click="closeDialog">{{ $t('Action.close') }}</button>
    </template>
  </modal>
</template>

<script>
import StlViewer from './StlViewer';
import * as util from '../util';

const view = require('../view.js'),
    viewData = {
      isHidden: true,
      isOpen: false,
      activeRequest: false,
      alertTitle: '',
      alertText: '',
      alertStyle: '',
      alertIcon: '',
      src: '',
      filename: '',
      downloadable: false,
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  components: {StlViewer},
  props: {
  },
  mounted() {
    this.reset();
  },
  computed: {
    isImage() {
      return /\.(png|jpg|jpeg|gif|svg)$/.test(this.filename)
    },
    isStl() {
      return /\.stl$/.test(this.filename)
    },
    iconColor() {
      return util.fileIconColor(this.extension);
    },
    extension() {
      return this.filename.split('.').pop() || '';
    }
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object' && i != 'isHidden' && i != 'isOpen') {
            viewData[i] = resetData[i];
          }
        }
      }
    },
    closeDialog() {
      if (this.activeRequest) {
        // Cancel the current request
      }

      this.$refs.modal.close(this);
    },
    openDialog(src, filename, downloadable) {
      this.src = src;
      this.filename = filename;
      this.downloadable = downloadable;
      this.$refs.modal.open(this);
      // this.animate();
    },
    closeAlert() {
      this.alertTitle = '';
      this.alertText  = '';
      this.alertStyle = '';
      this.alertIcon  = '';
    }
  }
});
</script>
<style scoped>
  .fileicon {
    display: inline-block;
    color: white;
    padding: 5px;
    text-transform: uppercase;
  }
  .fi-filename {
    text-align: center;
  }
  .attachment-item {
    display: inline-block;
  }
  .fi-container {
    text-align: center;
    vertical-align: middle;
    width: 100%;
    margin: 10px;
    padding: 5px;
  }

  .fi-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    line-height: 80px;
    overflow: hidden;
  }

  img {
    max-width: 100%;
  }
</style>
